import { InternalEventsOverviewModal } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/InternalEventsOverviewModal";
import { useInternalMessages } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/useInternalMessages";
import { partitionInternalMessagesRelatedToEvent } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/utils";
import { useState } from "react";
import { AlertsCounter } from "shared/components/dataDisplay/AlertsCounter";
import { DropsButton, Flex } from "shared/components/Spor";
import { NoteOutline24Icon } from "shared/icons/NoteIcon";
import { useDropsRole } from "stores/useDropsRole";
import { useTheme } from "styled-components";

export const InternalMessageOverviewButtonAndModal = () => {
  const [showModal, setShowModal] = useState(false);

  const internalMessageEvents = useInternalMessages();

  const [internalMessagesNoEvent] = partitionInternalMessagesRelatedToEvent(
    internalMessageEvents.data ?? [],
  );

  const theme = useTheme();

  const { isVaktleder } = useDropsRole();

  if (!isVaktleder()) return null;

  return (
    <>
      <DropsButton
        semantics="neutral"
        variant="tertiary"
        size="md"
        leftIcon={<NoteOutline24Icon />}
        aria-label="Se fremtidige hendelser"
        onClick={() => setShowModal(true)}
        style={{ width: "fit-content" }}
        pointerEvents="auto"
      >
        <Flex gap="6px" alignItems="center" color={theme.colorNeutralTextMain}>
          Interne meldinger
          <AlertsCounter
            alerts={internalMessagesNoEvent.length}
            semantics="transparent"
          />
        </Flex>
      </DropsButton>

      {showModal && (
        <InternalEventsOverviewModal
          onClose={() => setShowModal(false)}
          internalMessageEvents={internalMessageEvents}
        />
      )}
    </>
  );
};
